import { render, staticRenderFns } from "./OfferModal.vue?vue&type=template&id=afd901e2&scoped=true"
import script from "./OfferModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd901e2",
  null
  
)

export default component.exports